import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  form: {
    alignItems    : 'center',
    display       : 'flex',
    justifyContent: 'center',
    flexDirection : 'column',
    marginTop     : '64px',
  },
  root: {
    width    : '97%',
    maxHeight: '96%',
    maxWidth : '97%',
    margin   : 0,
  },
  content: {
    'overflow-y': 'unset',
  },
  titleContainer: {
    display       : 'flex',
    justifyContent: 'space-between',
    marginRight   : theme.spacing(3),
    alignItems    : 'center',

    position          : 'fixed',
    background        : 'white',
    zIndex            : 10,
    width             : 'inherit',
    borderRadius      : '4px 4px 0 0',
    borderBottom      : 'solid',
    '& > p:last-child': {
      fontSize  : theme.typography.button.fontSize,
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  actions: {
    padding       : theme.spacing(1.5),
    width         : '100%',
    display       : 'flex',
    justifyContent: 'space-between',
    flexDirection : 'row-reverse',

    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4),
    },
  },
  deleteButton: {
    color: theme.palette.error.main,
  },
}));
